
import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles((theme) => ({
    root: {
      padding: theme.spacing(4),
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(4, 0),
      },
    },
  }));
  